import {get, put, post, del, default as com} from '@/common/api'

const api = {


  saveReturnVisit:(para)=>{
     if (para.id) {
       return put(`/api/op/returnVisit/${para.id}`, para)
     } else {
      return post('/api/op/returnVisit', para)
     }
  },
  delReturnVisit:(id)=>{
    return del(`/api/op/returnVisit/${id}`)
  },

  getReturnVisit:(para)=>{
    return get(`/api/op/returnVisit`,para)
  },


  saveOpTreatment:(para)=>{
    if (para.id) {
      return put(`/api/op/opTreatment/${para.id}`, para)
    } else {
      return post('/api/op/opTreatment', para)
    }
  },

  getOpTreatment:(para)=>{
    return get(`/api/op/opTreatment/noVisitList`,para)
  },




}

export default api
